import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'secondsToMilliseconds', standalone:true})
export class SecondsToMillisecondsPipe implements PipeTransform {
    transform(value: number): number {
        return value * 1000;
    }
}
